import React from 'react';
import { useDrivingLicenceDocInfoPresenter } from './DrivingLicenceDocInfo.presenter';

import { DRIVING_LICENSE_PAGE_NUMBERS } from '../../FileUpload.constants';

import { ReactTooltipStyled } from 'components/modules/MainAnketa/MainAnketa.styles';
import * as S from '../../FileUpload.styles';

export const DrivingLicenceDocInfo = ({ pageList, classification }) => {
  const presenter = useDrivingLicenceDocInfoPresenter({ pageList });

  return (
    <S.AreaInfo data-test="drivingLicenceDocInfo">
      <S.InfoSvgStyled data-tip="" data-for="drivingLicenceDocInfo" />
      <ReactTooltipStyled id="drivingLicenceDocInfo" place="bottom">
        <S.PageList>
          {DRIVING_LICENSE_PAGE_NUMBERS.map((page, index) => (
            <S.PageError
              key={`_page_${index + 1}`}
              color={presenter.getColor(page)}
              sysName={classification.sysName}
            >
              {page}
            </S.PageError>
          ))}
        </S.PageList>
      </ReactTooltipStyled>
    </S.AreaInfo>
  );
};
